import { render, staticRenderFns } from "./ModalPackageList.vue?vue&type=template&id=5574bdab&scoped=true"
import script from "./ModalPackageList.vue?vue&type=script&lang=js"
export * from "./ModalPackageList.vue?vue&type=script&lang=js"
import style0 from "./ModalPackageList.vue?vue&type=style&index=0&id=5574bdab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5574bdab",
  null
  
)

export default component.exports